// Detecta si la app corre dentro del webview de Tauri (build desktop).
//
// Tauri 2.x inyecta `window.isTauri` (y `window.__TAURI_INTERNALS__`) en el
// webview ANTES de que corra el JS de la app, así que es seguro consultarlo
// desde `beforeLoad`, render o efectos. En el build web estos globals no
// existen, así que devuelve false y el flujo normal (landing) se mantiene.
export function isDesktopApp(): boolean {
  if (typeof window === "undefined") return false;
  const w = window as unknown as {
    isTauri?: boolean;
    __TAURI_INTERNALS__?: unknown;
  };
  return w.isTauri === true || w.__TAURI_INTERNALS__ != null;
}
